<template>
  <ul class="component-simpel-menu-list" ref="list">
    <slot/>
  </ul>
</template>
<style lang="scss">
  .component-simpel-menu-list{
    overflow:auto;
    height:100%;
    li{
      cursor:pointer;
      box-sizing:border-box;
      padding-left:$padding-small;
      padding-right:$padding-small;
      line-height:$line-height-middle;
      &:hover{
        background-color:rgba($color-highlight, 0.5);

        .hide{
          display:block;
        }
      }
    }
    li.focus{
      color:#FFF;
      background-color:$color-highlight;
      .hide{
        display:block;
      }
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/simple-menu/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/simple-menu/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/simple-menu/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-simple-menu')
  export default {
    name: 'base-simple-menu', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-simple-menu': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>